import React, { forwardRef } from 'react';
import { getContext } from 'react-recompose';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { box, colors, flex, overflow, sizes, spacing } from "../../../enums";
import { getFlexChildClassNames, getFlexClassNames, getHeightClassNames, getMarginClassNames, getPaddingClassNames, getWidthClassNames } from "./utils";
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      flex = _ref.flex,
      flexChild = _ref.flexChild,
      height = _ref.height,
      isInverted = _ref.isInverted,
      margin = _ref.margin,
      overflow = _ref.overflow,
      padding = _ref.padding,
      placement = _ref.placement,
      position = _ref.position,
      width = _ref.width;
  var flexChildClassNames = getFlexChildClassNames(flexChild);
  var flexClassNames = getFlexClassNames(flex);
  var heightClassNames = getHeightClassNames(height);
  var marginClassNames = getMarginClassNames(margin);
  var paddingClassNames = getPaddingClassNames(padding);
  var widthClassNames = getWidthClassNames(width);
  var classNames = cx('ck box', className, flexChildClassNames, flexClassNames, heightClassNames, marginClassNames, paddingClassNames, widthClassNames, (_cx = {}, _cx["color-" + color] = color, _cx.inverted = isInverted, _cx["overflow-" + overflow] = overflow, _cx["placement-" + placement] = placement, _cx["position-" + position] = position, _cx));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames
  }, children);
});
Box.displayName = 'Box';
Box.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf([colors.WHITE, colors.ERROR]),
  flex: PropTypes.shape({
    align: PropTypes.oneOf(flex.align.ALL),
    direction: PropTypes.oneOf(flex.directions.ALL),
    display: PropTypes.oneOf(flex.display.ALL),
    flow: PropTypes.oneOf(flex.flow.ALL),
    gap: PropTypes.oneOf([sizes.S, sizes.M]),
    justify: PropTypes.oneOf(flex.justify.ALL)
  }),
  flexChild: PropTypes.shape({
    basis: PropTypes.oneOf([spacing.AUTO]),
    grow: PropTypes.oneOf(flex.grow.ALL),
    shrink: PropTypes.oneOf(flex.shrink.ALL)
  }),
  height: PropTypes.shape({
    max: PropTypes.oneOf([spacing.FULL]),
    min: PropTypes.oneOf([spacing.FULL, spacing.ZERO]),
    value: PropTypes.oneOf(spacing.DIMENSION)
  }),
  isInverted: PropTypes.bool,
  margin: PropTypes.shape({
    all: PropTypes.oneOf(spacing.LAYOUT),
    top: PropTypes.oneOf(spacing.LAYOUT),
    bottom: PropTypes.oneOf(spacing.LAYOUT),
    left: PropTypes.oneOf(spacing.LAYOUT),
    right: PropTypes.oneOf(spacing.LAYOUT)
  }),
  overflow: PropTypes.oneOf(overflow.ALL),
  padding: PropTypes.shape({
    all: PropTypes.oneOf(spacing.LAYOUT),
    top: PropTypes.oneOf(spacing.LAYOUT),
    bottom: PropTypes.oneOf(spacing.LAYOUT),
    left: PropTypes.oneOf(spacing.LAYOUT),
    right: PropTypes.oneOf(spacing.LAYOUT)
  }),
  placement: PropTypes.oneOf(box.placements.ALL),
  position: PropTypes.oneOf(box.positions.ALL),
  width: PropTypes.shape({
    max: PropTypes.oneOf([spacing.FULL]),
    min: PropTypes.oneOf([spacing.FULL, spacing.ZERO]),
    value: PropTypes.oneOf(spacing.DIMENSION)
  })
};
Box.defaultProps = {
  children: null,
  className: '',
  color: null,
  flex: {
    align: null,
    direction: null,
    display: null,
    flow: null,
    gap: null,
    justify: null
  },
  flexChild: {
    basis: null,
    grow: null,
    shrink: null
  },
  height: {
    max: null,
    min: null,
    value: null
  },
  margin: {
    all: null,
    top: null,
    bottom: null,
    left: null,
    right: null
  },
  overflow: null,
  padding: {
    all: null,
    top: null,
    bottom: null,
    left: null,
    right: null
  },
  placement: null,
  position: null,
  width: {
    max: null,
    min: null,
    value: null
  }
};
export default getContext({
  isInverted: PropTypes.bool
})(Box);
//# sourceMappingURL=box.js.map